import React from 'react'

const First = () => {
  return (
    <div class="first">
        <p class="fontSize1 topTextPosition">SHIHO ASANO's<br></br>PORTFOLIO</p>
    </div>
  )
}

export default First